module.exports = __webpack_public_path__ + "img/LoT-logo.a775f2ca.svg";